module.exports = __webpack_public_path__ + "static/media/default-learning-material-avatar.d38c3caa.png";